<template>
    <div
        class="col-md-6 my-2"
        v-for="category in categories"
        :key="category.id"
    >
        <div class="card h-100 shadow rounded-3 animation border-2 search-card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-4 col-lg-3 my-auto">
                        <img
                            height="90"
                            class="w-100 rounded-3 cover shadow d-none d-md-block"
                            :src="`/storage/${category.image}`"
                            :alt="category.name_ka"
                            v-if="category.image"
                        />
                        <img
                            height="90"
                            class="w-100 rounded-3 cover shadow d-none d-md-block"
                            :src="`https://ui-avatars.com/api/?uppercase=true&bold=true&background=random&size=512&name=${category.name_ka}`"
                            :alt="category.name_ka"
                            v-else
                        />
                    </div>
                    <div class="col-md-8 col-lg-9 my-auto">
                        <a
                            :href="`/${name}/${category.id}`"
                            class="stretched-link text-decoration-none text-dark"
                        >
                            <h6 class="fw-bold mb-0">
                                {{ category.name_ka }}
                            </h6>
                        </a>
                        <small v-if="name === 'agencies'">
                            ტურისტული სააგენტო &bullet;
                            {{ category.municipality.name_ka }}
                        </small>
                        <small v-else-if="name === 'guides'"> გიდი </small>
                        <small v-else>
                            {{ category.category.name_ka }} &bullet;
                            {{ category.municipality.name_ka }}
                        </small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SearchCategory",
    props: ["categories", "name"],
};
</script>

<style scoped>
.search-card {
    transition: 0.2s;
}
.search-card:hover {
    border: 2px solid #cb0c9f;
}
</style>
